import { inject } from '@angular/core';
import { CrmResetPasswordHandleSuccessFunction } from '@touch4it/ng-swp/auth';
import { Router } from '@angular/router';

export const resetPasswordHandleSuccess: CrmResetPasswordHandleSuccessFunction = () => {
  const router = inject(Router);

  return () => {
    router.navigateByUrl('/').then();
  };
};
